import {
  Card,
  CardBody,
  Col,
  Container,
  Form,
  Row,
} from "reactstrap";
import BreadCrumb from "../../components/common/breadCrumb";
import React, { useState } from "react";
import * as Yup from "yup";
import { useFormik } from "formik";
import { InputPlaceHolder, passwordRegex, validationMessages } from "../../utils/helpers/validationMasseges";
import { getId } from "../../utils/helpers/custom";
import { changePassword } from "../../api/forgetPasswordApi";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { AuthLabels } from "../../common/constant/Authentication";
import BaseInput from "../../components/BaseComponents/BaseInput";
import { checkStatusCodeSuccess } from "../../utils/helpers/common";
import BaseButton from "../../components/BaseComponents/BaseButton";

const ChangePassword = () => {
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();
  const id = getId();

  const validation = useFormik({
    enableReinitialize: true,

    initialValues: {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      oldPassword: Yup.string().required(
        validationMessages.required(AuthLabels.OldPassword)
      ),
      newPassword: Yup.string()
        .required(validationMessages.required(AuthLabels.NewPassword))
        .test(
          "password-match",
          validationMessages.passwordsNotMatch(
            AuthLabels.OldPassword,
            AuthLabels.NewPassword
          ),
          function (value) {
            return value !== this.parent.oldPassword;
          }
        )
        .min(8, validationMessages.passwordLength(AuthLabels.NewPassword, 8))
        .matches(
          passwordRegex,
          validationMessages.passwordComplexity(AuthLabels.NewPassword)
        ),
      confirmPassword: Yup.string()
        .oneOf(
          [Yup.ref("newPassword")],
          validationMessages.passwordsMatch(
            AuthLabels.NewPassword,
            AuthLabels.ConfirmPassword
          )
        )
        .required(validationMessages.required(AuthLabels.ConfirmPassword)),
    }),
    onSubmit: (values) => {
      setLoading(true);
      const payload = {
        currentPassword: values.oldPassword,
        newPassword: values.newPassword,
        confirmPassword: values.confirmPassword,
      };
      changePassword(id, payload)
        .then((response) => {
          const responseBody = response?.data;
          if (checkStatusCodeSuccess(responseBody?.statusCode)) {
            toast.success(responseBody?.message);
            navigate("/login");
          } else {
            toast.error(responseBody?.message);
          }
        })
        .catch((err) => {
          toast.error(err?.data?.message);
          return err;
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb title="Change Password" pageTitle="HRMS" />
        <Row className="mb-4">
          <div className="col-sm order-3 order-sm-2 mt-3 mt-sm-0">
            <h5 className="fw-semibold mb-0">{AuthLabels.ChangePassword}</h5>
          </div>
        </Row>
        <Row className="d-flex justify-content-center g-2">
          <Col lg={6}>
            <Card>
              <CardBody>
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    validation.handleSubmit();
                    return false;
                  }}
                >
                  <Row className="g-2">
                    <Col lg={12}>
                      <div>
                        <BaseInput
                          className="form-control"
                          name="oldPassword"
                          type="password"
                          placeholder={InputPlaceHolder(AuthLabels.OldPassword)}
                          label={AuthLabels.OldPassword}
                          onChange={validation.handleChange}
                          handleBlur={validation.handleBlur}
                          value={validation.values.oldPassword}
                          touched={validation.touched.oldPassword}
                          error={validation.errors.oldPassword}
                          required
                        />
                      </div>
                    </Col>

                    <Col lg={12}>
                      <div>
                        <BaseInput
                          className="form-control"
                          name="newPassword"
                          type="password"
                          placeholder={InputPlaceHolder(AuthLabels.NewPassword)}
                          label={AuthLabels.NewPassword}
                          onChange={validation.handleChange}
                          handleBlur={validation.handleBlur}
                          value={validation.values.newPassword}
                          touched={validation.touched.newPassword}
                          error={validation.errors.newPassword}
                          required
                        />
                      </div>
                    </Col>

                    <Col lg={12}>
                      <div>
                        <BaseInput
                          className="form-control"
                          name="confirmPassword"
                          type="password"
                          placeholder={InputPlaceHolder(
                            AuthLabels.ConfirmPassword
                          )}
                          label={AuthLabels.ConfirmPassword}
                          onChange={validation.handleChange}
                          handleBlur={validation.handleBlur}
                          value={validation.values.confirmPassword}
                          touched={validation.touched.confirmPassword}
                          error={validation.errors.confirmPassword}
                          required
                        />
                      </div>
                    </Col>

                    <Col lg={12}>
                      <div className="text-end pt-3">
                        <BaseButton
                          color="success"
                          type="submit"
                          label={AuthLabels.ChangePassword}
                          loader={loading}
                          className="w-50"
                        />
                      </div>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ChangePassword;
